var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.179 2.60742H21.1024C25.1284 2.60742 27.3702 4.92738 27.3702 8.90259V22.3662C27.3702 26.4065 25.1284 28.6744 21.1024 28.6744H10.179C6.21684 28.6744 3.90991 26.4065 3.90991 22.3662V8.90259C3.90991 4.92738 6.21684 2.60742 10.179 2.60742ZM10.5311 8.68022V8.66719H14.4268C14.9885 8.66719 15.4447 9.12336 15.4447 9.68249C15.4447 10.2573 14.9885 10.7134 14.4268 10.7134H10.5311C9.96935 10.7134 9.51448 10.2573 9.51448 9.69683C9.51448 9.13639 9.96935 8.68022 10.5311 8.68022ZM10.5311 16.6041H20.7493C21.3098 16.6041 21.7659 16.1479 21.7659 15.5875C21.7659 15.0271 21.3098 14.5696 20.7493 14.5696H10.5311C9.96935 14.5696 9.51448 15.0271 9.51448 15.5875C9.51448 16.1479 9.96935 16.6041 10.5311 16.6041ZM10.5309 22.5608H20.7491C21.2692 22.5087 21.6615 22.0642 21.6615 21.5442C21.6615 21.0098 21.2692 20.5667 20.7491 20.5145H10.5309C10.1399 20.4754 9.7619 20.6579 9.55336 20.9968C9.34482 21.3226 9.34482 21.7527 9.55336 22.0916C9.7619 22.4174 10.1399 22.6129 10.5309 22.5608Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.f75f7f3cdb58ea70fb737cac712863d6.svg";
export { ForwardRef as ReactComponent };